import React from "react";
import { Grid, Box, Typography, Paper, Button } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import KingBedIcon from "@mui/icons-material/KingBed";
import { ReactComponent as Doctoricon } from "../../Images/Doctorcolor.svg";
import Medicaliconuse from "../../Images/Imagemedical.png";

const StaffResourcesSection = (props) => {
  const { doctorCardData, selectedView, onViewChange } = props;

  return (
    <Paper elevation={0} className="p-3 mb-4 figma-wrapper">
      <Typography
        variant="subtitle1"
        fontWeight={600}
        mb={2}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <img
          src={Medicaliconuse}
          alt="medal"
          style={{
            width: "22px",
            height: "22px",
          }}
        />
        Staff & Resources
      </Typography>

      <Grid container spacing={2}>
        {/* Doctors Card */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "12px",
              backgroundColor: "#F5F7FA",
              boxShadow: "0px 4px 12px rgba(0, 0, 0,)",
              border: selectedView === "doctors" ? "1px solid #4F46E5" : "1px solid transparent",
              transition: "all 0.3s ease",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {/* LEFT */}
              <Box display="flex" gap={1.5} alignItems="flex-start">
                {/* ICON */}
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    backgroundColor: "#6B8CFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Doctoricon
                    sx={{
                      fontSize: 20,
                      "& path": {
                        fill: "#4F46E5",
                      },
                    }}
                  />
                </Box>

                {/* TEXT */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#6B7280",
                      lineHeight: "16px",
                    }}
                  >
                    No. of Doctors
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#111827",
                      lineHeight: "24px",
                      mt: "2px",
                    }}
                  >
                    {doctorCardData?.doctor_count || 0}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#9CA3AF",
                      lineHeight: "14px",
                      mt: "2px",
                      maxWidth: "170px",
                    }}
                    className="para_doctor"
                  >
                    Doctors associated with this facility
                  </Typography>
                </Box>
              </Box>

              {/* RIGHT BUTTON */}
              <Button
                variant="outlined"
                size="small"
                className="view_button"
                onClick={() => onViewChange("doctors")}
              >
                View
              </Button>
            </Box>
          </Paper>
        </Grid>

        {/* Nurses Card */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "12px",
              backgroundColor: "#F5F7FA",
              boxShadow: "0px 4px 12px rgba(0, 0, 0,)",
              border: selectedView === "nurses" ? "1px solid #4F46E5" : "1px solid transparent",
              transition: "all 0.3s ease",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {/* LEFT */}
              <Box display="flex" gap={1.5} alignItems="flex-start">
                {/* ICON */}
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    backgroundColor: "#10B981",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GroupIcon sx={{ color: "#ffff", fontSize: 18 }} />
                </Box>

                {/* TEXT */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#6B7280",
                      lineHeight: "16px",
                    }}
                  >
                    No. of Nurses
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#111827",
                      lineHeight: "24px",
                      mt: "2px",
                    }}
                  >
                    {doctorCardData?.nurse_count || 0}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#9CA3AF",
                      lineHeight: "14px",
                      mt: "2px",
                      maxWidth: "170px",
                    }}
                    className="para_doctor"
                  >
                    Nurses associated with this facility
                  </Typography>
                </Box>
              </Box>

              {/* RIGHT BUTTON */}
              <Button
                variant="outlined"
                size="small"
                className="view_button"
                onClick={() => onViewChange("nurses")}
              >
                View
              </Button>
            </Box>
          </Paper>
        </Grid>

        {/* Beds Card */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "12px",
              backgroundColor: "#F5F7FA",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, )",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {/* LEFT */}
              <Box display="flex" gap={1.5} alignItems="flex-start">
                {/* ICON */}
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    backgroundColor: "#F59E0B",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <KingBedIcon sx={{ color: "#ffff", fontSize: 18 }} />
                </Box>

                {/* TEXT */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#6B7280",
                      lineHeight: "16px",
                    }}
                  >
                    No. of Beds
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#111827",
                      lineHeight: "24px",
                      mt: "2px",
                    }}
                  >
                    {doctorCardData?.facility_total_beds_count || 0}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#9CA3AF",
                      lineHeight: "14px",
                      mt: "2px",
                      maxWidth: "170px",
                    }}
                    className="para_doctor"
                  >
                    Beds reserved for Cancer Care Treatment
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default StaffResourcesSection;